import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import "bootstrap-icons/font/bootstrap-icons.css";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useDispatch } from "react-redux";
import { setTrue } from "core/redux/features/quiz/LogoutSlice";
const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;
  const dispatch=useDispatch();
  // Retrieve user data from localStorage
  const role = localStorage.getItem("roles");
  const name = "Admin";
    const lname = localStorage.getItem("last_name");
  const token = localStorage.getItem("token");
  // Handle profile navigation based on role
  const handleProfileByRole = () => {
    console.log("Profile clicked, role:", role);
    if (role === "Admin") {
      navigate(route.adminDashboard);
    } else if (role === "Student") {
      navigate(route.studentProfile);
    } else {
      console.warn("Unknown role, redirecting to login");
      navigate(route.login);
    }
  };
  // Handle logout
  const handleLogout =async () => {
     await dispatch(setTrue())
    localStorage.clear();
    navigate(route.login);
  };
  // Handle scroll effect for header
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  // Initialize Bootstrap dropdowns
  useEffect(() => {
    import("bootstrap").then((bootstrap) => {
      const dropdowns = document.querySelectorAll(".dropdown-toggle");
      dropdowns.forEach((dropdown) => {
        new bootstrap.Dropdown(dropdown);
      });
    });
  }, []);
  return (
    <header
      className="header-two border-bottom pt-3 pb-3"
    >
      <div className="container">
        <div className="header-nav d-flex align-items-center justify-content-between">
          {/* Logo */}
          <div className="navbar-logo">
            <Link to={route.homefour} className="header-logo">
              <ImageWithBasePath
                src="assets/img/logo/AviationLogo-08.png"
                className="logo img-fluid"
                alt="Aviation Logo"
                width="70"
              />
            </Link>
          </div>
          <div className=" d-flex align-items-center">
            {token ? (
              <div className="d-flex align-items-center gap-2 dropdown profile-dropdown">
                 <button
                    className="d-flex align-items-center border-0 p-0 bg-transparent"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-label="Toggle user menu"
                    onClick={() => console.log("Profile dropdown clicked")}
                  >
                    <span className="user-img">
                      <img
                        src={
                          localStorage.getItem("image") ||
                          "https://secure.gravatar.com/avatar/87cff3ad6a241cb35b7edd6abbd319b2?s=96&d=mm&r=g"
                        }
                        alt="User Avatar"
                        style={{
                          height: "50px",
                          width: "50px",
                          objectFit: "cover",
                        }}
                        className="rounded-circle"
                      />
                    </span>
                  </button>
                  {/* Name and Role - Vertical */}
                  <div className="d-flex flex-column">
                    <p className="mb-0 fw-semibold">{localStorage.getItem("first_name")||name}</p>
                   {role==="Admin"&& <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Admin
                    </p>}
                     {role==="Student"&& <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Student
                    </p>}
                  </div>
                <div className="dropdown-menu dropdown-menu-end">
                  {role === "Student" && (
                    <ul className="profile-body list-unstyled m-0 p-3">
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center rounded fw-medium p-2"
                          to={route.studentDashboard}
                        >
                          <i className="isax isax-security-user me-2" />
                          My Profile
                        </Link>
                      </li>
                    </ul>
                  )}
                  {role === "Admin" && (
                    <ul className="profile-body list-unstyled m-0 p-3">
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center rounded fw-medium p-2"
                          to={route.instructorDashboard}
                        >
                          <i className="isax isax-security-user me-2" />
                          Admin Dashboard
                        </Link>
                      </li>
                    </ul>
                  )}
                  <div className="profile-footer p-3">
                    <button
                      className="btn btn-secondary d-flex align-items-center justify-content-center w-100 rounded-pill"
                      onClick={handleLogout}
                      aria-label="Logout"
                    >
                      <i className="isax isax-logout me-2" />
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <Link
                  to={route.login}
                  className="btn btn-primary d-none d-md-inline-flex align-items-center me-2 rounded-pill"
                  aria-label="Sign In"
                >
                  Sign In
                </Link>
                <Link
                  to={route.login}
                  className="d-flex align-items-center d-md-none"
                  aria-label="Sign In"
                >
                  <i
                    className="bi bi-box-arrow-in-right gradient-icon"
                    style={{ fontSize: "28px" }}
                  ></i>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header